

<div *ngIf="showModal">
    <div class="modal-backdrop fade in" [style.display]="showModal ? 'block' : 'none'"></div>
    <div class="modal" tabindex="-1" role="dialog" style="display: block" [style.display]="showModal ? 'block' : 'none'">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" aria-label="Close" (click)="onClickCloseModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Bearbeite Kontakt</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <dx-form [formData]="kontaktShadow"
                                     [labelLocation]="'top'"
                                     #form1
                                     (onFieldDataChanged)="onValueChanged($event)">

                                <dxi-item [label]="{text: 'Kontakttyp'}" dataField="kontaktTypeId" editorType="dxSelectBox" [editorOptions]="{ items: available_KontaktTypeItems, value: kontaktShadow.kontaktTypeId,  displayExpr: 'name',  valueExpr: 'id' }">
                                    <dxi-validation-rule type="required" message="Kontakttyp wird benötigt!"></dxi-validation-rule>
                                </dxi-item>
                                <dxi-item dataField="name" [label]="{text: 'Name'}">
                                    <dxi-validation-rule type="required" message="Kontakt-Name wird benötigt!"></dxi-validation-rule>
                                </dxi-item>
                                <dxi-item dataField="vorname" [label]="{text: 'Vorname'}">
                                </dxi-item>

                                <dxi-item dataField="telefon1" [label]="{text: 'Telefon 1'}">
                                </dxi-item>

                                <dxi-item dataField="telefon2" [label]="{text: 'Telefon 2'}">
                                </dxi-item>

                                <dxi-item dataField="fax" [label]="{text: 'Fax'}">
                                </dxi-item>

                                <dxi-item dataField="mail1" [label]="{text: 'Email 1'}">
                                    <dxi-validation-rule type="email" message="Keine gültige Kontakt-Email!"></dxi-validation-rule>
                                </dxi-item>

                                <dxi-item dataField="mail2" [label]="{text: 'Email 2'}">
                                    <dxi-validation-rule type="email" message="Keine gültige Kontakt-Email!"></dxi-validation-rule>
                                </dxi-item>

                                <dxi-item dataField="webAdresse" [label]="{text: 'Web'}">
                                    <dxi-validation-rule type="pattern" pattern="^www." message="Keine gültige URL!"></dxi-validation-rule>
                                </dxi-item>
                            </dx-form>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-primary" (click)="onClickSaveEdit()"><span>Übernehmen</span></button>
                    <button type="button" class="btn btn-sm btn-warning" (click)="onClickCloseModal()"><span>Abbruch</span></button>
                </div>
            </div>
        </div>
    </div>
</div>
